var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.015,
    height: 6.431,
    viewBox: "0 0 11.015 6.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sort-down-solid",
    d: "M17.861,288h9.162a.925.925,0,0,1,.654,1.578L23.1,294.159a.92.92,0,0,1-1.3,0l-4.585-4.581A.925.925,0,0,1,17.861,288Z",
    transform: "translate(-16.934 -288)",
    fill: "#b51430"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort_down.bbe0d3af149160b91d638f307d443849.svg";
export { ForwardRef as ReactComponent };